import React from 'react';
import PropTypes from 'prop-types';
import { stepCompilaQuesito, stepInformazioniAggiuntive, stepSceltaServizio } from './useNuovoQuestitoSteps';
import FooterSceltaServizio from './stepSceltaServizio/FooterSceltaServizio';
import FooterCompilaQuesito from './stepCompilaQuestionario/FooterCompilaQuesito';
import FooterInformazioniAggiuntive from './stepInformazioniAggiuntive/FooterInformazioniAggiuntive';

const FooterModaleNuovoQuestito = ({ currentStep, ...props }) => (
  <>
    {currentStep === stepSceltaServizio && <FooterSceltaServizio {...props} />}
    {currentStep === stepCompilaQuesito && <FooterCompilaQuesito {...props} />}
    {currentStep === stepInformazioniAggiuntive && <FooterInformazioniAggiuntive {...props} />}
  </>
);

FooterModaleNuovoQuestito.propTypes = {
  codiceUfficio: PropTypes.string,
  currentStep: PropTypes.oneOf([stepCompilaQuesito, stepSceltaServizio, stepInformazioniAggiuntive]).isRequired,

  onIndietroClick: PropTypes.func.isRequired,
  onAvantiClick: PropTypes.func.isRequired,
  servizio: PropTypes.shape({
    IdServizio: PropTypes.number,
  }),
  categoria: PropTypes.shape({
    IdCategoria: PropTypes.number,
    IdCategoriaPadre: PropTypes.number,
    InfoEvasione: PropTypes.string,
    EsclusivaEccellenza: PropTypes.bool,
    argomenti: PropTypes.arrayOf({
      IdCategoria: PropTypes.number,
      IdCategoriaPadre: PropTypes.number,
    }),
  }),
  argomento: PropTypes.shape({
    IdCategoria: PropTypes.number.isRequired,
    Categoria: PropTypes.string.isRequired,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
  }),
  oggetto: PropTypes.string,
  messaggio: PropTypes.string,
};

FooterModaleNuovoQuestito.defaultProps = {
  codiceUfficio: undefined,
  servizio: undefined,
  categoria: undefined,
  argomento: undefined,
  messaggio: undefined,
  oggetto: undefined,
};

export default FooterModaleNuovoQuestito;
